export const getPath = (path: string) => {
    return `${path}${window.location.search}`;
};
